<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">Anexos</span>
                    </b-card-header>
                    <b-card-body>
                        <app-tabela
                            idTabela="tblAnexos"
                            :itens="anexos"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                            :bordered="false"
                            :small="false"
                        >
                            <template slot="botoes">
                                <b-button-group class="float-right">
                                    <b-button
                                        class="mr-2"
                                        variant="primary"
                                        @click.stop="inserirAnexo()"
                                        v-if="mostrarBtnInserirAnexo"
                                        ><i class="fa fa-plus"></i> Inserir
                                        Anexo</b-button
                                    >
                                    <!-- <b-button
                                        variant="warning"
                                        @click.stop="$emit('fechar')"
                                        ><i class="fa fa-times-circle"></i>
                                        Fechar Anexos</b-button
                                    > -->
                                </b-button-group>
                                <slot name="botoes"></slot>
                            </template>
                            <template slot="acoes" slot-scope="data">
                                <pagamento-anexo-download
                                    :pagamentoAnexo="data"
                                    :pagamentosServicos="pagamentosServicos"
                                ></pagamento-anexo-download>
                                <span class="text-primary">
                                    <i
                                        v-if="mostrarBtnAtualizarAnexo"
                                        class="fa fa-pencil-square-o fa-lg icon-button ml-1"
                                        title="Atualizar dados do anexo"
                                        @click.stop="atualizarAnexo(data.pagamentoAnexoId)"
                                    ></i>
                                </span>
                                <pagamento-anexo-excluir
                                    :pagamento="pagamento"
                                    :pagamentoAnexo="data"
                                    :pagamentosServicos="pagamentosServicos"
                                    @obterPagamentoAtualizado="
                                        obterPagamentoAtualizado()
                                    "
                                    class="ml-1"
                                    v-if="mostrarBtnExcluirAnexo"
                                ></pagamento-anexo-excluir>
                            </template>
                        </app-tabela>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
        <pagamento-anexo-form
            ref="pagamentoAnexoForm"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
            :pagamento="pagamento"
            :pagamentosServicos="pagamentosServicos"
            :mostrarCampoNumeroDocumento="false"
            :anexoAtualizarId="anexoAtualizarId"
            :operacao="anexoOperacao"
        ></pagamento-anexo-form>
    </div>
</template>

<script>
import PagamentoAnexoDownload from './PagamentoAnexoDownload'
import PagamentoAnexoForm from './PagamentoAnexoForm'
import PagamentoAnexoExcluir from './PagamentoAnexoExcluir'
import { pagamentoStatus } from './PagamentoStatus'

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            anexos: [],
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'anexoTipoDescricao',
                    label: 'Tipo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descricao',
                    label: 'Descritivo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'numeroNotaDocumento',
                    label: 'Número da Nota',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'codigoVerificacao',
                    label: 'Código de Verificação',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'dataEmissao',
                    label: 'Data da Emissão',
                    type: 'date'
                },
                {
                    key: 'nomeArquivoOriginal',
                    label: 'Arquivo'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime'
                }
            ],
            itensPorPagina: 0,
            anexoAtualizarId: null,
            anexoOperacao: null
        }
    },

    methods: {
        obterAnexos() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .obterAnexos(this.$route.params.pagamentoId)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.anexos = response.data
                        } else {
                            this.$toast.error(
                                'Não foi possível obter os documentos.',
                                'ERROR',
                                this.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        inserirAnexo() {
            this.$refs.pagamentoAnexoForm.mostrarModal = true
            this.anexoAtualizarId = null
            this.anexoOperacao = 'INSERIR'
        },

        atualizarAnexo(anexoPagamentoId) {
            this.$refs.pagamentoAnexoForm.mostrarModal = true
            this.anexoAtualizarId = anexoPagamentoId
            this.anexoOperacao = 'ATUALIZAR'
        },

        obterPagamentoAtualizado() {
            this.obterAnexos()
            this.$emit('obterPagamentoAtualizado')
        }
    },

    computed: {
        permiteAcao() {
            return this.pagamento != null
                && (this.edicaoRequisitanteFornecedor
                    || this.edicaoFinalizacao) 
        },

        edicaoRequisitanteFornecedor() {
            return (
                (this.pagamento.status == pagamentoStatus.CRIADO
                    || this.pagamento.status == pagamentoStatus.REPROVADO)
                && (this.$route.name == 'DespesasGerais_Requisitantes_Pagamentos_Detalhar' 
                   || this.$route.name == 'DespesasGerais_Fornecedores_Pagamentos_Detalhar')
            )
        },

        edicaoFinalizacao() {
            return (
                (this.pagamento.status == pagamentoStatus.EM_ANALISE
                    || this.pagamento.status == pagamentoStatus.REPROVADO_PELO_SETOR_FINANCEIRO)
                && this.$route.name == 'DespesasGerais_Finalizacao_Pagamentos_Detalhar')
        },

        mostrarBtnInserirAnexo() {
            return this.$temAcesso('DESP-GERAIS-PAG-ANX-01') 
                && this.permiteAcao
        },

        mostrarBtnExcluirAnexo() {
            return this.$temAcesso('DESP-GERAIS-PAG-ANX-02') 
                && this.permiteAcao 
        },

        mostrarBtnAtualizarAnexo() {
            return this.$temAcesso('DESP-GERAIS-PAG-ANX-03') 
                && this.permiteAcao 
        },
    },

    created() {
        this.obterAnexos()
    },

    components: {
        PagamentoAnexoForm,
        PagamentoAnexoDownload,
        PagamentoAnexoExcluir
    }
}
</script>
